export default "__VITE_ASSET__BaFteprK__"